// extracted by mini-css-extract-plugin
module.exports = {"label":"FileUpload_label__BpXRO"};